import React, {
  createRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import NewProjectContext from "../../../contexts/NewProjectContext";
import { ReactComponent as FileUploaderPlaceholderSvg } from "../../../assets/icons/fileuploader-placeholder.svg";
import AppContext from "../../../AppContext.jsx";
import { langComponent, PAGE_STATE } from "../../../constants/index.jsx";

import { toast } from "react-toastify";
import FileUpload from "./WorkFileUpload.jsx";

const prefix = "new-project-work-exchange-file";

const ProjectFile = ({ handleFileChange }) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  const { goForward, goBackward, details, setDetails } =
    useContext(NewProjectContext);
  const [dragActive, setDragActive] = useState(false);
  const [newDownload, setNewDownload] = useState(false);
  const [files, setFiles] = useState(details?.workExchange?.files ?? []);

  const handleFiles = (newFiles) => {
    if (newFiles.length === 0) return;
    setNewDownload(true);

    setFiles((curr) => {
      // * Filter out duplicate files
      const existingFilenames = curr.map((c) => c.name);

      const _files = [...newFiles].filter(
        (file) => !existingFilenames.includes(file.name)
      );

      return [...curr, ..._files];
    });
  };

  const handleRemoveFile = (file) => {
    setFiles((curr) => [...curr.filter((f) => f.name !== file.name)]);
    toast.info("Removed File!");
  };

  const handleDragDropEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if ((e.type === "dragenter" || e.type === "dragover") && !dragActive) {
      setDragActive(true);
    }

    if ((e.type === "dragleave" || e.type === "drop") && dragActive) {
      setDragActive(false);
    }

    if (e.type === "drop") {
      handleFiles(e.dataTransfer.files);
    }
  };

  useEffect(() => {
    const totalSize = files.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.size;
    }, 0);

    if (totalSize / 1000000000 >= 5) {
      toast.warn("Over limit file size");
      return;
    }
    handleFileChange(files);
  }, [files]);

  useEffect(() => {
    if (details.files) {
      setFiles(details.files);
    }
  }, [details]);

  return (
    <div className={`${prefix}`}>
      <div
        className={`${prefix}-fileuploader ${
          dragActive ? `${prefix}-fileuploader--highlight` : ""
        }`}
        onDragEnter={handleDragDropEvents}
        onDragOver={handleDragDropEvents}
        onDragLeave={handleDragDropEvents}
        onDrop={handleDragDropEvents}
      >
        <FileUploaderPlaceholderSvg />
        <p className={`${prefix}-fileuploader__info`}>
          {Translation("Drop your files here or")}{" "}
          <label
            className={`${prefix}-fileuploader__input-trigger`}
            htmlFor={`${prefix}-fileuploader__input`}
          >
            {Translation("browse")}
          </label>
          <br />
          <span className={`${prefix}-fileuploader__limit`}>
            {Translation("Limit")} 5 GB
          </span>
        </p>
        <input
          id={`${prefix}-fileuploader__input`}
          type="file"
          multiple
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
      <div className={`${prefix}-gallery-scroller`}>
        <div className={`${prefix}-gallery`}>
          {[...files].map((file, index) => {
            return (
              <FileUpload
                file={file}
                key={index}
                handleRemoveFile={handleRemoveFile}
                isDelete={details?.downloads > 0 ? false : true}
                newDownload={newDownload}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

ProjectFile.propTypes = {
  handleFileChange: PropTypes.func,
};
ProjectFile.defaultProps = {
  handleFileChange: () => {},
};

export default ProjectFile;
